/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useCallback, useContext, useMemo } from 'react'
import { PaginationContext } from './PaginationProvider'
import { Group, SegmentedControl, SegmentedControlProps, Text, TextProps } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

export type PaginationLimitsProps = Partial<SegmentedControlProps> & {
  limits?: number[],
  textProps?: TextProps,
}

function PaginationLimits (props: PaginationLimitsProps) {
  const {
    limits = [10, 20, 30],
    textProps,
    ...others
  } = props

  const {
    limit,
    setLimit,
    totalElements
  } = useContext(PaginationContext)

  const sortedLimits = useMemo<string[]>(() => {
    const list = [...limits]

    if (!list.includes(limit)) {
      list.push(limit)
    }
    return list.sort((a, b) => {
      if (a < b) {
        return -1
      }
      if (a > b) {
        return 1
      }
      return 0
    }).map(String)
  }, [limit, limits])

  const handleLimitChange = useCallback((value: string) => {
    setLimit(Number(value))
  }, [setLimit])

  return (
    <Group>
      <SegmentedControl
        disabled={totalElements <= 0}
        {...others}
        data={sortedLimits}
        onChange={handleLimitChange}
        value={String(limit)}
      />
      <Text
        c="dimmed"
        size="xs"
        tt="lowercase"
        {...textProps}
      >
        <FormattedMessage
          id="elements_per_page"
          defaultMessage="Elements per page"
        />
      </Text>
    </Group>
  )
}

export default PaginationLimits
